import { render, staticRenderFns } from "./NoticeListView.vue?vue&type=template&id=1c07754c&scoped=true&"
import script from "./NoticeListView.vue?vue&type=script&lang=js&"
export * from "./NoticeListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07754c",
  null
  
)

component.options.__file = "NoticeListView.vue"
export default component.exports